import React, {useState} from 'react'

import {useTranslation} from 'react-i18next'
import {Baseline} from '../../../Layout/Grid'
import {Recipient} from '../../../../state/rest'
import RecipientModal from './RecipientModal'
import {LabelInput} from '../../../Atoms/Forms'

import {getRecipientsNames} from './AlarmSettingsUtils'

interface AlarmMethodsProps {
  controller: {
    recipients: Recipient[]
    extRecipients: Recipient[]
    isOpen: boolean
    toggleModal: () => void
    handleSave: (r: Recipient[], er: Recipient[]) => void
    open: () => void
    close: () => void
  }
}

const AlarmRecipientsWidget = ({controller: uc}: AlarmMethodsProps) => {
  const {t} = useTranslation('alarms')
  const openedAtRef = React.useRef(0)

  const names = getRecipientsNames([...uc.recipients, ...uc.extRecipients], 5)

  return uc ? (
    <div>
      <Baseline>
        <LabelInput
          id="selected-recipients"
          name="recipientsDisplay"
          type="text"
          readOnly
          value={names}
          labelText={t('alarms:labels.recipient', 'Who will receive alarm messages?')}
          onClick={e => {
            e.stopPropagation()
            setTimeout(() => {
              openedAtRef.current = Date.now()
              if (!uc.isOpen) uc.open() // explicit open; don’t toggle
            }, 0)
          }}
        />
      </Baseline>
      <RecipientModal
        isOpen={uc.isOpen}
        onSave={(newRes: Recipient[], newExtRes: Recipient[]) => uc.handleSave(newRes, newExtRes)}
        onCancel={() => uc.close()}
        recipients={uc.recipients}
        extRecipients={uc.extRecipients}
      />
    </div>
  ) : null
}

export default AlarmRecipientsWidget
